import React, { HtmlHTMLAttributes } from 'react'
import LoaderSVG from './iconSvgs/loader';
import AssetsSVG from './iconSvgs/assets';
import InventorySVG from './iconSvgs/inventory';

import { PiBellSimple, PiCalendarDotsLight, PiCaretCircleLeft, PiCaretCircleRight, PiChartPieSlice, PiClipboardTextLight, PiCodepenLogoLight, PiMapPinLine, PiNoteDuotone, PiSidebar, PiSlidersHorizontal, PiSpeedometerLight, PiStorefront, PiUserList, PiUsersFourLight } from "react-icons/pi";
import { GoArrowLeft, GoFile, GoShieldCheck } from "react-icons/go";
import { BsGraphUpArrow, BsListCheck } from "react-icons/bs";
import { SlSettings } from "react-icons/sl";
import { MdLogout, MdOutlineRefresh } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import { FaTimes } from "react-icons/fa";
import { IoIosArrowDown, IoIosWarning } from "react-icons/io";
import { GrLocation } from "react-icons/gr";
import { RxCross2 } from "react-icons/rx";
import ThreedoteSVG from './iconSvgs/threedote';
import { FaDownload, FaTrashCan } from "react-icons/fa6";
import { TbFilterPlus } from "react-icons/tb";

export type iconNames = 'loader' | 'warning'| 'file' | 'meter' | 'delete' | 'location' | 'assets' | 'warranties' | 'inventory' | 'lease' | 'depreciation' | 'calendar' | 'workorders' | 'checklist' | 'purchase' | 'vendors' | 'users' | 'reports' | 'settings' | 'allusers' | 'logout' |
 'notification' | 'sidebar' | 'search'| 'add-filter' |'reset' | 'close' | 'circleright' | 'circleleft' | 'filter' | 'arrow-left' | 'threedote' | 'arrowdown' | 'grlocation' | 'cross'| 'download';

interface props extends HtmlHTMLAttributes<HTMLDivElement> {
    name: iconNames;
    size?: number;
    className?: string;
    onClick?: (e: any) => void
}

const Icon: React.FC<props> = ({
    children,
    name,
    size = 1,
    className = '',
    onClick,
    ...args
}) => {


    const getIconByName = (name: iconNames) => {
        switch (name) {
            case 'loader': return <LoaderSVG size={size} />;
            case 'meter': return <PiSpeedometerLight style={{ fontSize: `${size}rem` }} />;
            case 'location': return <PiMapPinLine style={{ fontSize: `${size}rem` }} />; 
            case 'grlocation': return <GrLocation style={{ fontSize: `${size}rem` }} />; 
            case 'warranties': return <GoShieldCheck style={{ fontSize: `${size}rem` }} />;
            case 'lease': return <PiCodepenLogoLight style={{ fontSize: `${size}rem` }} />;
            case 'depreciation': return <BsGraphUpArrow style={{ fontSize: `${size}rem` }} />;
            case 'calendar': return <PiCalendarDotsLight style={{ fontSize: `${size}rem` }} />;
            case 'workorders': return <PiNoteDuotone style={{ fontSize: `${size}rem` }} />;
            case 'checklist': return <BsListCheck style={{ fontSize: `${size}rem` }} />;
            case 'purchase': return <PiClipboardTextLight style={{ fontSize: `${size}rem` }} />;
            case 'vendors': return <PiStorefront style={{ fontSize: `${size}rem` }} />;
            case 'users': return <PiUserList style={{ fontSize: `${size}rem` }} />;
            case 'reports': return <PiChartPieSlice style={{ fontSize: `${size}rem` }} />;
            case 'settings': return <SlSettings style={{ fontSize: `${size}rem` }} />;
            case 'allusers': return <PiUsersFourLight style={{ fontSize: `${size}rem` }} />;
            case 'logout': return <MdLogout style={{ fontSize: `${size}rem` }} />;
            case 'notification': return <PiBellSimple style={{ fontSize: `${size}rem` }} />;
            case 'sidebar': return <PiSidebar style={{ fontSize: `${size}rem` }} />;
            case 'search': return <IoSearchOutline style={{ fontSize: `${size}rem` }} />;
            case 'circleright': return <PiCaretCircleRight style={{ fontSize: `${size}rem` }} />;
            case 'circleleft': return <PiCaretCircleLeft style={{ fontSize: `${size}rem` }} />;
            case 'filter': return <PiSlidersHorizontal style={{ fontSize: `${size}rem` }} />;
            case 'arrow-left': return <GoArrowLeft style={{ fontSize: `${size}rem` }} />;
            case 'reset': return <MdOutlineRefresh style={{ fontSize: `${size}rem` }} />;
            case 'close': return <FaTimes style={{ fontSize: `${size}rem` }} />;
            case 'arrowdown': return <IoIosArrowDown style={{ fontSize: `${size}rem` }} />;
            case 'cross': return <RxCross2 style={{ fontSize: `${size}rem` }} />;
            case 'delete': return <FaTrashCan style={{ fontSize: `${size}rem` }} />;
            case 'warning': return <IoIosWarning style={{ fontSize: `${size}rem` }} />;
            case 'download' :  return <FaDownload style={{ fontSize: `${size}rem` }} />;
            case 'add-filter' :  return <TbFilterPlus style={{ fontSize: `${size}rem` }} />;
            case 'file' :  return <GoFile style={{ fontSize: `${size}rem` }} />;


            case 'assets': return <AssetsSVG size={size} />;
            case 'inventory': return <InventorySVG size={size} />;
            case 'threedote': return <ThreedoteSVG size={size} />;

            default: return null;
        }
    }

    const getStyle = () => {
        let style: any = {}
        if (onClick) {
            style.cursor = 'pointer';
        }
        return style
    }

    return (
        <span onClick={onClick ? onClick : (e: any) => { }} className={`${className} ${(onClick) ? 'cursor-pointer' : ''}`}
            style={getStyle()}>
            {getIconByName(name)}
        </span>
    )
}

export default Icon;
